import { connect, useSelector } from 'react-redux';
import { camelizeKeys } from 'humps';
import { getUserApiClient } from 'lib/SplashApiClient/subclients/UserApiClient';

import { isUser, getIsUserLoading, getUserId, getUser } from './selectors';

import { APP } from '../index';

// Constants
export const USER = 'user';

export const SET_USER = `${APP}/SET_USER`;
export const UPDATE_USER = `${APP}/UPDATE_USER`;
export const SET_USER_LOADING = `${APP}/SET_USER_LOADING`;

// Reducers
export const INIT_STATE = {
    [USER]: {
        data: {},
        loading: false,
    },
};

export const reducers = {
    [SET_USER](state, { payload }) {
        return {
            ...state,
            [USER]: { ...state[USER], data: payload },
        };
    },
    [UPDATE_USER](state, { payload }) {
        return {
            ...state,
            [USER]: {
                ...state[USER],
                data: {
                    ...(state[USER].data || {}),
                    ...payload,
                },
            },
        };
    },

    [SET_USER_LOADING](state, { payload }) {
        return {
            ...state,
            [USER]: { ...state[USER], loading: payload },
        };
    },
};

// Actions
export const setUser = (userData) => ({
    type: SET_USER,
    payload: userData,
});

export const updateUser = (userData) => ({
    type: UPDATE_USER,
    payload: userData,
});

export const setLoading = (loading) => ({
    type: SET_USER_LOADING,
    payload: loading,
});

// Thunks
export const fetchUser = () => (dispatch) => {
    dispatch(setLoading(true));

    getUserApiClient()
        .fetchUser()
        .then((res) => {
            const camelizedUserData = camelizeKeys(res.data);
            dispatch(updateUser(camelizedUserData));
            dispatch(setLoading(false));
        })
        .catch((err) => {
            dispatch(setLoading(false));
            throw err;
        });
};

export const fetchUserOnce = () => (dispatch, getState) => {
    const state = getState();
    const isUserDefined = isUser(state);
    const isUserLoading = getIsUserLoading(state);

    if (!isUserDefined && !isUserLoading) {
        dispatch(fetchUser);
    }
};

const mapStateToPropsId = (state) => ({
    userId: getUserId(state),
});

const mapStateToPropsUser = (state) => ({
    user: getUser(state),
});

export const withUserId = (Component) => connect(mapStateToPropsId)(Component);
export const withUser = (Component) => connect(mapStateToPropsUser)(Component);

export function useUser() {
    return useSelector(getUser);
}

// App module
export default {
    initialState: INIT_STATE,
    reducers,
};
